export const Luxury = ({ width = 20, height = 20, ...props }: any) => (
  <img src="/icons/Luxury.svg" alt="Luxury" width={width} height={height} {...props} />
)
